import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { apiCall, fmtDate, euro } from "./rUtils";

export function UninvoicedPanel({ token, onOpen, reloadKey, onChanged }) {
  const [list, setList] = useState([]);
  const [drafts, setDrafts] = useState([]);
  useEffect(() => {
    apiCall(token, "/rechnungen/admin/uninvoiced").then((d) => setList(d.bookings)).catch((e) => toast.error(e.message));
    apiCall(token, "/rechnungen/admin/list?status=entwurf").then((d) => setDrafts(d.invoices)).catch(() => {});
  }, [token, reloadKey]);
  const create = async (b) => {
    try { const r = await apiCall(token, `/rechnungen/admin/drafts/from-appointment/${b.appointment_id}`, { method: "POST" }); toast.success("Entwurf erstellt"); onChanged(); onOpen(r.invoice_id); } catch (e) { toast.error(e.message); }
  };
  return (
    <div className="space-y-6" data-testid="uninvoiced-panel">
      <section>
        <h3 className="font-['Bebas_Neue'] text-2xl text-white">Entwürfe ({drafts.length})</h3>
        {!drafts.length && <p className="text-sm text-[#71717A]">Keine offenen Entwürfe.</p>}
        {drafts.map((r) => (
          <button key={r.invoice_id} type="button" onClick={() => onOpen(r.invoice_id)} className="w-full text-left bg-[#1A1A1A] border border-white/10 hover:border-[#c1ff72]/40 p-3 mt-2 flex flex-wrap gap-4 text-sm" data-testid={`draft-${r.invoice_id}`}>
            <span className="text-white">{r.customer_name}</span><span className="text-[#A1A1AA] flex-1 truncate">{r.service}</span><span>{euro(r.total)}</span>
          </button>
        ))}
      </section>
      <section>
        <h3 className="font-['Bebas_Neue'] text-2xl text-white">Bestätigte Buchungen ohne Rechnung ({list.length})</h3>
        <p className="text-xs text-[#71717A] mb-2">Offene Terminanfragen erscheinen hier nicht – nur bestätigte oder abgeschlossene Buchungen mit Preis. Trainingskarten werden über die Karte abgerechnet.</p>
        {!list.length && <p className="text-sm text-[#71717A]" data-testid="uninvoiced-empty">Alle bestätigten Buchungen sind abgerechnet.</p>}
        {list.map((b) => (
          <div key={b.appointment_id} className="bg-[#1A1A1A] border border-white/10 p-3 mt-2 flex flex-wrap items-center gap-4 text-sm" data-testid={`uninvoiced-${b.appointment_id}`}>
            <span className="text-white w-28">{fmtDate(b.date)} {b.time}</span>
            <span className="flex-1 min-w-[180px]"><span className="text-white block">{b.customer_name}</span><span className="text-xs text-[#A1A1AA]">{b.training_name} · {b.duration} Min{b.player_count > 1 ? ` · ${b.player_count} Teilnehmer` : ""}</span></span>
            <span className="text-[#c1ff72]">{euro(b.total_price)}</span>
            <Button size="sm" onClick={() => create(b)} className="bg-[#c1ff72] text-black hover:bg-[#a8e65c] rounded-none" data-testid={`create-draft-${b.appointment_id}`}>Rechnung vorbereiten</Button>
          </div>
        ))}
      </section>
    </div>
  );
}
